import { Typography } from "@/components/atoms";

export const EmptyPaymentAttempts = () => {
  return (
    <div className="mt-3 w-full rounded-lg border border-neutral-mid-gray p-6">
      <Typography>At the moment, there is no payment attempts available.</Typography>
    </div>
  );
};
